import {Component, EventEmitter, Input, OnInit, Output} from "@angular/core";
import {ActivatedRoute} from "@angular/router";
import {ToastrService} from "ngx-toastr";
import {FormControllerService} from "../../../../../../../services/form-controller/form-controller.service";
import FormUtils from "../../../../../../utils/form-utils.component";
import {BaseError} from "../../../../../base-error";

@Component({
  selector: "field-set-calculate-shares-value",
  templateUrl: "./field-set-calculate-shares-value.component.html",
  styles: [],
})
export class FieldSetCalculateSharesValueComponent extends BaseError implements OnInit {
  @Input() public guides: any[];
  @Input() public fieldOptions: any;
  @Output() public dataChanged = new EventEmitter();
  public visibleFields: any[];
  public visibleGuides: any[];

  public dataChangedEvent(event) {
    this.dataChanged.emit(event);
  }

  constructor(private route: ActivatedRoute,
              private formControllerService: FormControllerService,
              toastr: ToastrService) {
    super(toastr);
  }

  public ngOnInit(): void {
    this.route.params.subscribe((params) => {
      const serviceId = params.serviceId;
      this.getSystemFields(serviceId);
      this.filterGuides();
    });
  }

  private getSystemFields(serviceId: string) {
    this.formControllerService.getFilteredFormFields(serviceId, "number", false, false, false, false, false, false, false).subscribe(
      (data) => {
        this.visibleFields = data;
      },
      (error) => this.showErrorMessageWithTitle("Unable to get service form field list!", error),
    );
  }

  public filterGuides() {
        this.visibleGuides = this.guides ? this.guides.filter((guide) => FormUtils.convertDeterminantTypeToFieldType(guide.type) === this.fieldOptions.inputType) : [];
  }

}
